var map = {
	"./about-cropped.png": 800,
	"./about.jpg": 6723,
	"./article/jacques.jpeg": 5890,
	"./avatar/avatar-a.svg": 2423,
	"./avatar/avatar-alt.svg": 7385,
	"./avatar/avatar-h.svg": 9255,
	"./avatar/avatar.svg": 7822,
	"./bg.jpg": 8496,
	"./blank-wide.svg": 9818,
	"./blank.svg": 1421,
	"./blob.png": 6391,
	"./blob.svg": 3189,
	"./emoji/emoji-eyebrow.png": 775,
	"./emoji/emoji-smile.png": 4958,
	"./emoji/emoji-think.png": 6361,
	"./emoji/emoji-wink.png": 1440,
	"./favicons/fav-face.svg": 3678,
	"./favicons/fav.svg": 2712,
	"./favicons/favicon.svg": 413,
	"./favicons/j-uni.svg": 2047,
	"./j-logo.svg": 4823,
	"./j-uni.svg": 3824,
	"./jacques.jpeg": 3101,
	"./logo.png": 4427,
	"./luna.jpg": 5336,
	"./luna1.jpg": 8745,
	"./luna2.jpg": 5543,
	"./me.jpg": 9325,
	"./noise.png": 8976,
	"./noise2.png": 7562,
	"./portrait.jpg": 9604,
	"./profile.jpg": 158,
	"./profile2.jpg": 1532,
	"./shapes.png": 5652,
	"./shapes.svg": 6736,
	"./splash.svg": 4085,
	"./splash4.svg": 8408,
	"./templates/archive/hand2.png": 3252,
	"./templates/archive/hands.png": 1581,
	"./templates/archive/template-desktop-mobile.svg": 5422,
	"./templates/archive/template-lg.svg": 8992,
	"./templates/archive/template-mobile-4.svg": 4716,
	"./templates/archive/template-mobile-v2.svg": 2475,
	"./templates/archive/template-sm.svg": 1606,
	"./templates/template-desktop-blank.svg": 9246,
	"./templates/template-mobile-blank.svg": 2014,
	"./templates/template-mobile.svg": 1578,
	"./templates/template-preview.svg": 1849,
	"./templates/template-v2.svg": 1134,
	"./work/dod.svg": 788,
	"./work/glo.svg": 1697,
	"./work/gob.svg": 3490,
	"./work/j.svg": 329,
	"./work/mailback.svg": 2133,
	"./work/placeholder.png": 4178
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;